import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/MyTask/CheckList.html'
})

export class CheckListComponent implements OnInit {
   
    userDetail: any;
    public constants: Constants;
    public TaskItems: any[] = [];
    public CheckList: any[] = [];
    active = true;
    public subscription: any;
    public isFormSubmitted: boolean = false;
    public editTaskTypeId: any = 0;
    public CheckListName:any;
    public SequenceId :any = 1;
    public showLoader = false;
   
     constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private activatedRoute: ActivatedRoute,
        private _Router: Router) {
        this.subscription =
            this.activatedRoute.queryParams.subscribe(
                (param: any) => {
                    if (param["myTask"]) {
                        console.log(JSON.stringify(JSON.parse(param["myTask"])));
                        this.editTaskTypeId = (JSON.parse(param["myTask"]));
                                         }
                });
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        console.log(this.constants.enumFeeType.Per_Project);
      
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {

     this.GetTaskLists();
     if(this.editTaskTypeId!=null||this.editTaskTypeId!="")
           {
              this.GetCheckList();
           }
          
 }

 
//  CheckListCompleted(item,event)
//     if(event == true){
//         item.CompletedBy = this.userDetail.SiteUserId;
//         item.CompletedDate = moment().format('DD/MM/YYYY') ;
//     }
//     else{
//         item.CompletedBy = 0;
//         item.CompletedDate ="";
//     } 
//  }


    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }
    


public GetTaskLists(){
    this._httpService.ajaxPost('MyTask/GetTaskList',{"ProjectId":0,"logginUserId":this.userDetail.SiteUserId}).subscribe(
        data => {
            this.TaskItems = data["TaskList"];
               }
    );
}

AddCheckListToList(){
if(this.validate()){

var CheckListItem = {
    TaskCheckListId : 0,
    CheckListName : this.CheckListName,
    Status : 0,
    CompletedBy :null,
    CompletedDate : "",
    SequenceId: this.SequenceId,
    TaskCompleted:false
};
this.CheckList.push(CheckListItem);
this.SequenceId=this.SequenceId+1;
this.CheckList = JSON.parse(JSON.stringify(this.CheckList));
this.CheckListName="";
}
}
GetCheckList(){

this.showLoader = true;

this._httpService.ajaxPost('CheckList/GetCheckList',{"TaskId":this.editTaskTypeId}).subscribe(
    data => {
        this.CheckList = data["CheckList"];
      this.SequenceId=1
      if(this.CheckList.length>0)
         {
         
                this.CheckList.forEach(element => {
                element.SequenceId = this.SequenceId
                this.SequenceId=this.SequenceId+1;
                if(element.CompletedDate!=null && element.CompletedDate!="")
                {
                    element.TaskCompleted =true
                }
               else
                {
                element.TaskCompleted =false
                }
              }); 

  
        }
           }
);
this.showLoader = false;

}
DeleteCheckList(item){
    this.CheckList = JSON.parse(JSON.stringify(this.CheckList.filter(m => m.SequenceId != item.SequenceId)));
    
                   }

validate(){


    var mandatory = "";
    var invalid = "";
    var functional = "";

  
            if(this.CheckListName == "" || this.CheckListName == null)
            {
                mandatory = mandatory + "<br>CheckList";
            }
            if(this.CheckListName.length >200 )
            {
                mandatory = mandatory + "<br>CheckList length should be less than 200 charecter";
            }
           
    if (mandatory == "" && invalid == "" && functional == "") {
        return true;
    } else {
        var msg = "";
        if (mandatory != "") {
            msg = msg + "Please enter : " + mandatory;
            msg = msg + "<br>";
        }
        if (invalid != "") {
            msg = msg + "Please enter valid : " + invalid;
            msg = msg + "<br>";
        }
        if (functional != "") {
            msg = msg + functional;
        }
        this._sharedService.ShowMessage("error|" + msg);
    }
    return false;
}

public CancelMyCheckList() {
       
                    // this.newForm();
                     this._Router.navigateByUrl('/MyTaskList');
                    
                 }
            
AddCheckList(){
    this.showLoader = true;
    var objItem = {
        TaskId : this.editTaskTypeId,
        CheckList : this.CheckList
    };
    this._httpService.ajaxPost('CheckList/AddUpdateCheckList', objItem).subscribe(
        data => {

            var msg = data["Status"].Message.split('|');
            if (msg.length > 1) {
                msg[0] = msg[0].toLowerCase();
                this._Router.navigateByUrl('/MyTaskList');
                this._sharedService.ShowMessage(data["Status"].Message);
            }
            else {
                this._sharedService.ShowMessage(data["Status"].Message);
            }

            },
        err => {
            this.showLoader = false;
            this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
            this.showLoader = false;
        }
    );

    
}
               

}







/** WEBPACK FOOTER **
 ** ./TypeScripts/MyTask/CheckList.component.ts
 **/